import "./SessionListItem.scss";
import "./DashboardGlobal.scss";
import { Link } from "react-router-dom";
import moment from "moment";
import Score from "./Score";
import { AppButton, Panel } from "../ui";
import { getPreferredSessionIdentifier } from "../../utility/sessionIdentifiers";

const SessionListItem = ({ session }) => {
  const formatSeconds = (seconds) =>
    `${Math.floor(seconds / 60)}:${(Math.floor(seconds) % 60)
      .toString()
      .padStart(2, "0")}`;
  const startMoment = moment(session.startTime);
  const dateLabel = startMoment.isValid() ? startMoment.format("MMM D, YYYY") : "—";
  const timeLabel = startMoment.isValid() ? startMoment.format("h:mm A") : "—";

  const cleanedName = session.firstName
    ? session.firstName
        .replace(/[.,/#!$%^&*;:{}=\-_`~()\s?]+|\b(um|you)\b/gi, "")
        .trim()
    : "";

  const sessionLabel = cleanedName ? "Student" : "Anonymous";
  const sessionKey = getPreferredSessionIdentifier(session);
  const sessionPrimary = cleanedName || sessionKey || "—";

  const canView = Boolean(sessionKey);
  const sessionRoute = `/sessions/${encodeURIComponent(sessionKey)}`;

  return (
    <Panel className="grid-row session-list-item" hoverable>
      <div className="grid-column narrow date">
        <div className="session-date">
          {dateLabel}
        </div>
        <div className="session-time">
          {timeLabel}
        </div>
      </div>

      <div className="grid-column slim name">
        <p className="session-name-top">{sessionLabel}</p>
        <h3 className="session-name-main" title={sessionPrimary}>
          {sessionPrimary}
        </h3>
      </div>

      <div className="grid-column narrow session-metric session-metric--score" data-label="Score">
        <Score score={session.meanScore} />
      </div>

      <div className="grid-column narrow session-metric session-metric--insights" data-label="Insights">
        <h3>{session.responseCount}</h3>
      </div>

      <div className="grid-column slim session-metric session-metric--duration" data-label="Time spent">
        <h3>{formatSeconds(session.secondsSpent)}</h3>
      </div>

      <div className="grid-column narrow session-actions">
        {canView ? (
          <Link className="session-list-item__view-link" to={sessionRoute}>
            <AppButton className="session-list-item__view-button" kind="secondary">
              View session
            </AppButton>
          </Link>
        ) : (
          <AppButton
            className="session-list-item__view-button"
            kind="secondary"
            disabled
            title="Missing session id"
          >
            View session
          </AppButton>
        )}
      </div>
    </Panel>
  );
};

export default SessionListItem;
